import { colors } from '@/theme/foundations/colors';

export const customStyles = (newStyles = []) => {
  const defaultStyles = {
    control: (base, state, newStyles) => {
      return {
        ...base,
        padding: state.selectProps?.hasSearchIcon ? '0 12px' : 0,
        fontSize: '12px',
        borderRadius: '6px',
        border: state.selectProps?.border === false ? 0 : '1px solid',
        borderColor: `${colors['border-color']} !important`,
        background: state.isDisabled ? colors['secondary-50'] : '#fff',
        boxShadow: state.selectProps.hasError ? '0 0 0 2px #E53E3E' : 'none',
        color: colors['secondary-700'],
        fontWeight: 450,
        '&:hover': {
          cursor: 'pointer',
          border: state.selectProps?.border === false ? 0 : '1px solid',
          borderColor: `${colors['primary-500']} !important`,
        },
        '&:focus': {
          background: '#FFF',
          borderColor:
            state.selectProps?.borderColor && colors['secondary-300'],
        },
        ...newStyles,
      };
    },

    input: (baseStyles, state, newStyles) => ({
      ...baseStyles,
      color: colors['secondary-700'],
      ...newStyles,
    }),

    placeholder: (baseStyles, state, newStyles) => ({
      ...baseStyles,
      color: colors['secondary-500'],
      ...newStyles,
    }),

    multiValue: (base, state, newStyles) => ({
      ...base,
      background: colors['secondary-50'],
      borderRadius: '6px',
      padding: '0 2px',
      border: '1px solid #EFECF0',
      // boxShadow: '0 1px 2px 0 #101828',
      color: colors['secondary-700'],
      ...newStyles,
    }),

    singleValue: (base, state, newStyles) => ({
      ...base,
      color: colors['secondary-700'],
      ...newStyles,
    }),

    dropdownIndicator: (base, state, newStyles) => ({
      ...base,
      color: state?.isDisabled
        ? colors['secondary-500']
        : colors['secondary-700'],
      ...newStyles,
    }),

    multiValueLabel: (base, state, newStyles) => ({
      fontSize: '12px',
      padding: '4px',
      fontWeight: 600,
      color: colors['secondary-700'],
      ...newStyles,
    }),
    multiValueRemove: (base, state, newStyles) => ({
      ...base,
      '&:hover': {
        background: colors['secondary-50'],
      },
      ...newStyles,
    }),

    menu: (base, state, newStyles) => ({
      ...base,
      border: '1px solid ',
      borderColor: colors['border-color'],
      boxShadow: '0px 4px 12px 6px rgba(46, 47, 48, 0.06)',
      padding: '4px 8px',
      ...newStyles,
    }),

    menuList: (base, state, newStyles) => ({
      ...base,
      maxHeight: '200px',
      ...newStyles,
    }),

    option: (base, state, newStyles) => ({
      ...base,
      fontSize: '12px',
      fontWeight: 500,
      cursor: 'pointer',
      color: colors['secondary-700'],
      background:
        state.isSelected || state.isFocused ? colors['secondary-50'] : '#FFF',
      '&:hover': {
        background: colors['secondary-50'],
      },
      borderRadius: '6px',
      ...newStyles,
    }),

    loadingMessage: (base, state, newStyles) => ({
      ...base,
      padding: 0,
      ...newStyles,
    }),
    menuPortal: (base, state, newStyles) => ({
      ...base,
      zIndex: 9999,
      ...newStyles,
    }),
  };

  if (newStyles?.length === 0) return defaultStyles;

  const styledDefaultStyles = {};

  for (const type in defaultStyles) {
    const styledFunction = defaultStyles[type];
    const relevantNewStyles = newStyles.find(
      (style) => style.type === type
    )?.newStyles;
    styledDefaultStyles[type] = (base, state) =>
      styledFunction(base, state, relevantNewStyles);
  }

  return styledDefaultStyles;
};
